define([], function () {

    //-------------------------------------------------------------- Start of nmCrypto.js

    var chromeExtension = "gmdjnnkmjgkmielnkjfdhmcdfgcanihm";
    var productID = "com.cfca.cryptokit.bsfg";

    var extensionName = productID + ".extension";
    var reqEventName = productID + ".request";
    var respEventName = productID + ".response";

    var Browser = {
        IE: "Internet Explorer",
        Edge: "Edge",
        Chrome: "Chrome",
        Safari: "Safari",
        Firefox: "Firefox",
    };

    // Encapsulate Chrome sendMessage callback to Promise
    function SendMessageforChrome(request) {
        return new Promise(function (resolve, reject) {
            chrome.runtime.sendMessage(chromeExtension, request, function (response) {
                if (response) {
                    if (0 == response.errorcode) {
                        resolve(response);
                    }
                    else {
                        reject(response);
                    }
                }
                else {
                    var result = new Object();
                    result.errorcode = 1;
                    result.result = chrome.runtime.lastError.message;
                    reject(result);
                }
            });
        });
    }

    // Encapsulate Edge&Firefox event to Promise
    function SendMessagebyEvent(request) {
        var event = new CustomEvent(reqEventName, { detail: request });
        document.dispatchEvent(event);

        return new Promise(function (resolve, reject) {

            var responseEventName = respEventName;
            if (request.funcInfo != undefined && request.funcInfo.randomId != undefined)
                responseEventName += ("." + request.funcInfo.randomId);

            document.addEventListener(responseEventName, function CallBack(e) {
                document.removeEventListener(e.type, CallBack);
                var eJson = JSON.parse(e.detail);
                if (null != eJson && 0 == eJson.errorcode) {
                    resolve(eJson);
                }
                else {
                    reject(eJson);
                }
            }, false);
        });
    }

    function SendMessage(browser, requestJSON) {
        if (Browser.Chrome == browser) {
            return SendMessageforChrome(requestJSON);
        }
        else {
            return SendMessagebyEvent(requestJSON);
        }
    }


    function checkExtension(browser) {
        return new Promise(function (resolve, reject) {
            var result = new Object();
            if (Browser.Chrome == browser) {
                // chrome.runtime.sendMessage() could check extension  existence.
                if (chrome.runtime) {
                    resolve(browser);
                }
                else {
                    result.errorcode = 2;
                    result.result = "Extension does not exist!";
                    reject(result);
                }
            }
            else if (Browser.Edge == browser || Browser.Firefox == browser) {
                if (document.getElementById(extensionName)) {
                    resolve(browser);
                }
                else {
                    result.errorcode = 2;
                    result.result = "Extension does not exist!";
                    reject(result);
                }
            }
            else {
                result.errorcode = 3;
                result.result = "Only support Chrome/Edge/Firefox";
                reject(result);
            }
        });
    }

    function nmCryptokit(browser) {

        this.browser = browser;
    };

    function GenerateRandomId() {
        var charstring = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz1234567890';
        var maxPos = charstring.length;
        var randomId = '';
        for (i = 0; i < 10; i++) {
            randomId += charstring.charAt(Math.floor(Math.random() * maxPos));
        }
        return randomId;
    }

    nmCryptokit.prototype.init = function () {

        var browser = this.browser;

        return checkExtension(browser)
            .then(function (browser) {
                var request = new Object();
                request.action = "connect";
                request.host = productID;
                return SendMessage(browser, request);
            }).then(function () {
                var request = new Object();
                var funcInfo = new Object();
                funcInfo.function = "checkHost";
                funcInfo.params = null;
                request.action = "invoke";
                request.funcInfo = funcInfo;
                return SendMessage(browser, request);
            });
    }


    nmCryptokit.prototype.uninit = function () {

        var request = new Object();
        request.action = "disconnect";
        request.host = productID;

        return SendMessage(this.browser, request);
    }


    nmCryptokit.prototype.selectCertificate = function (strSubjectDNFilter, strIssuerDNFilter, strSerialNo) {

        var request = new Object();
        var funcInfo = new Object();
        var paramArr = new Array();
        var randomId = GenerateRandomId();

        paramArr.push(strSubjectDNFilter);
        paramArr.push(strIssuerDNFilter);
        paramArr.push(strSerialNo);

        funcInfo.function = "SelectCertificate";
        funcInfo.params = paramArr;
        funcInfo.randomId = randomId;

        request.action = "invoke";
        request.funcInfo = funcInfo;

        return SendMessage(this.browser, request);
    }


    nmCryptokit.prototype.getSignCertInfo = function (strInfoType) {

        var request = new Object();
        var funcInfo = new Object();
        var paramArr = new Array();
        var randomId = GenerateRandomId();

        paramArr.push(strInfoType);

        funcInfo.function = "GetSignCertInfo";
        funcInfo.params = paramArr;
        funcInfo.randomId = randomId;

        request.action = "invoke";
        request.funcInfo = funcInfo;

        return SendMessage(this.browser, request);
    }


    nmCryptokit.prototype.signMsgPKCS7Attached = function (strSource, strSelectedAlg) {

        var request = new Object();
        var funcInfo = new Object();
        var paramArr = new Array();
        var randomId = GenerateRandomId();

        paramArr.push(strSource);
        paramArr.push(strSelectedAlg);

        funcInfo.function = "SignMsgPKCS7Attached";
        funcInfo.params = paramArr;
        funcInfo.randomId = randomId;

        request.action = "invoke";
        request.funcInfo = funcInfo;

        return SendMessage(this.browser, request);
    }


    nmCryptokit.prototype.getLastErrorDesc = function () {

        var request = new Object();
        var funcInfo = new Object();
        var randomId = GenerateRandomId();

        funcInfo.function = "GetLastErrorDesc";
        funcInfo.params = null;
        funcInfo.randomId = randomId;

        request.action = "invoke";
        request.funcInfo = funcInfo;

        return SendMessage(this.browser, request);
    }

    //-------------------------------------------------------------- End of nmCrypto.js

    return nmCryptokit;

});